export const APPROVED_COLOR = '#67b443';
export const PENDING_COLOR = '#d9a931';
export const SICKNESS_COLOR = '#E14E2E';
export const PUBLIC_HOLIDAY_COLOR = 'var(--purple)';
export const EMPTY_ROW_ID = 'empty-row';
